// @owners { team: patients }
/**
 * Web has no counterpart to native's PaymentSheet (see
 * AddPaymentCardPaymentSheet.native.tsx). This stub exists only so shared
 * call sites (e.g. AddPaymentMethodActionSheet) type-check and resolve on both
 * platforms, matching this repo's dual-file convention (see
 * AddPaymentCard.native.tsx / .web.tsx). It is never reachable at runtime -
 * the PaymentSheet flag paths only execute on native.
 */
import { type PaymentMethodType } from '~shared/constants';

type Props = {
  readonly onClose: () => void;
  readonly onCancel?: () => void;
  readonly onStripeUnavailable?: () => void;
  readonly onPresented?: () => void;
  readonly paymentMethodType?: PaymentMethodType;
  readonly presentation?: 'inline' | 'headless';
};

export const AddPaymentCardPaymentSheet: (props: Props) => never = () => {
  throw new Error('AddPaymentCardPaymentSheet is native-only and should never render on web.');
};
